export default __webpack_public_path__ + "static/media/A3UW24GFA2_02.e73e4ff8.png";